import { Button, Divider, Grid, IconButton, InputAdornment, Typography } from "@mui/material";
import { Formik } from "formik";
import { useEffect, useMemo, useState } from "react";
import * as yup from 'yup';
import CustomAutoComplete from "../../../components/admin/common/AutoComplete/CustomAutoComplete";
import { showErrorNotification, showInfoNotification, showSuccessNotification, showWarningNotification } from "../../../components/admin/common/NotiService";
import OZInput from "../../../components/admin/common/OZInput";
import LoadingScreen from "../../../components/admin/common/OZLoadingScreen/OZLoadingScreen";
import OZSelect from "../../../components/admin/common/OZSelect";
import SimpleSwitch from "../../../components/admin/common/OZSwitch/SimpleSwitch";
import { ScrollToFieldError } from "../../../components/admin/common/ScrollToFieldError";
import { addsubadmin, getAgentGroupsList, getIvrFlow, getProfileList, getSipBargeExtensionDropdown, getSkillsDropdown, getUserCampaignList, getUserLoggedIn, updatesubadminById } from "../../../services/api-service";
import { writeAccess } from "../../../services/page-service";
import { ReactComponent as HidePassword } from "../../../static/icons/hidePassword.svg";
import { ReactComponent as ShowPassword } from "../../../static/icons/showPassword.svg";
import { ADMIN_FORM_MODES } from "../../../utils/constants";
import { checkRoles } from "../../../utils/util";

const styles = {
  box: {
    position: 'relative',
    backgroundColor: '#edf5ff',
    height: '42px',
    margin: '10px',
    alignItems: 'center',
    boxShadow: '0px 9px 12px rgba(0, 0, 0, 0.2)',
    borderRadius: '8px',
    display: 'inline-block',
    padding: '12px',
  },
  arrow: {
    position: 'absolute',
    top: '-9px',
    left: '6%',
    transform: 'translateX(-50%)',
    width: '0',
    height: '0',
    borderLeft: '20px solid transparent',
    borderRight: '20px solid transparent',
    borderBottom: '22px solid #edf5ff',
  },
  text: {
    fontWeight: 500,
  },
};

const AddSubUser = (props) => {

  let styleFieldHeader = useMemo(
    () => ({ fontSize: "14px", fontWeigth: 400, marginLeft: '1%', marginTop: '-0.5%' }),
    []);

  const inputSipField = (props?.inputSipField || false);
  const [loading, setLoading] = useState(false);
  const [profileListData, setProfileListData] = useState([]);
  const [agentGrpListData, setAgentGrpListData] = useState([]);
  const [campaignListData, setCampaignListData] = useState([]);
  const [skillsListData, setSkillsListData] = useState([]);
  const [ivrList, setIvrList] = useState([]);
  const [disableForm, setDisableForm] = useState(props?.mode != ADMIN_FORM_MODES.add || false);
  const [sipBargeExtensionData, setSipBargeExtensionData] = useState([]);
  let [updatedRowData, setUpdatedRowData] = useState({});
  const agentList = useMemo(() => props?.agentList || [], [props?.agentList])
  const fwpNumberList = useMemo(() => props?.fwpNumberList || [], [props?.fwpNumberList])

  useEffect(() => {
    getProfileListData();
    getGroupsList();
    getCampaignList();
    getSkillsList();
    getIvrList();
    if (checkRoles("ROLE_ADMIN")) {
      getSipBargeExtensionOptions();
    }
  }, [])

  async function getProfileListData() {
    setLoading(true);
    try {
      getProfileList()
        .then((resp) => {
          setProfileListData(resp.Data);
          setLoading(false);
        })
        .catch((e) => {
          setProfileListData([]);
          setLoading(false);
        });
    } catch (e) {
      setProfileListData([]);
      showErrorNotification("Error in profile list");
      setLoading(false);
    }
  };

  async function getGroupsList() {
    setLoading(true);
    try {
      getAgentGroupsList()
        .then((resp) => {
          setAgentGrpListData(resp?.Data || []);
          setLoading(false);
        })
        .catch((e) => {
          setAgentGrpListData([]);
          setLoading(false);
        });
    } catch (e) {
      showErrorNotification("Error in groups list");
      setAgentGrpListData([]);
      setLoading(false);
    }
  };

  async function getSkillsList() {
    setLoading(true);
    try {
      getSkillsDropdown().then((resp) => {
        const respData = resp?.Data;
        setSkillsListData(respData || []);
        setLoading(false);
      }).catch((e) => {
        setSkillsListData([]);
        setLoading(false);
      });
    } catch (e) {
      showErrorNotification("Error in Skills list");
      setSkillsListData([]);
      setLoading(false);
    }
  };

  async function getCampaignList() {
    setLoading(true);
    try {
      getUserCampaignList()
        .then((resp) => {
          const respData = resp?.Data;
          setCampaignListData(respData || []);
          setLoading(false);
        })
        .catch((e) => {
          setCampaignListData([]);
          setLoading(false);
        });
    } catch (e) {
      showErrorNotification("Error in groups list");
      setCampaignListData([]);
      setLoading(false);
    }
  };

  async function getIvrList() {
    try {
      setLoading(true);
      const resp = await getIvrFlow();
      if (resp && resp?.Data?.length > 0)
        setIvrList(resp.Data.map((item) => ({ flowId: item?.id, flowName: item?.flowName })));
    } catch (e) {
      console.error(JSON.stringify(e));
    } finally {
      setLoading(false);
    }
  };

  async function getSipBargeExtensionOptions() {
    try {
      getSipBargeExtensionDropdown()
        .then((resp) => {
          const extractedValues = resp.Data.map(item => item.name);
          setSipBargeExtensionData(extractedValues);
        })
        .catch((e) => {
          setSipBargeExtensionData([]);
        });
    } catch (e) {
      showErrorNotification("Error in Sip Barge Extension list");
    }
  }

  function setUpdatedData(data) {
    let updatedData = structuredClone(data);
    if (props?.mode !== ADMIN_FORM_MODES.add) {
      updatedData.confirmPassword = data.password;
      if (data?.appProfileUser) {
        updatedData.appProfileUser = data?.appProfileUser[0];
      }
      if (data?.userCampaigns?.length == 0) {
        if (data?.isCampaignValue == "0") {
          updatedData.userCampaigns = [{ campaignId: "0_all", campaignName: 'All' }]
        } else if (data?.isCampaignValue == "-1") {
          updatedData.userCampaigns = [{ campaignId: "-1_none", campaignName: 'None' }]
        } else {
          updatedData.userCampaigns = [{ campaignId: "0_all", campaignName: 'All' }]
        }
      }
      if (data?.userGroups?.length == 0) {
        if (data?.isGroupValue == "0") {
          updatedData.userGroups = [{ id: "0_all", name: 'All' }]
        } else if (data?.isGroupValue == "-1") {
          updatedData.userGroups = [{ id: "-1_none", name: 'None' }]
        } else {
          updatedData.userGroups = [{ id: "0_all", name: 'All' }]
        }
      }
      if (data?.userIvr?.length == 0) {
        if (data?.isFlowValue == "0") {
          updatedData.userIvr = [{ flowId: "0_all", flowName: 'All' }]
        } else if (data?.isFlowValue == "-1") {
          updatedData.userIvr = [{ flowId: "-1_none", flowName: 'None' }]
        } else {
          updatedData.userIvr = [{ flowId: "0_all", flowName: 'All' }]
        }
      }
      if (data?.userSkills?.length == 0) {
        if (data?.isSkillValue == "0") {
          updatedData.userSkills = [{ id: "0_all", skillName: 'All' }]
        } else if (data?.isSkillValue == "-1") {
          updatedData.userSkills = [{ id: "-1_none", skillName: 'None' }]
        } else {
          updatedData.userSkills = [{ id: "0_all", skillName: 'All' }]
        }
      }
      setUpdatedRowData(updatedData);
    }
  };

  useEffect(() => {
    setUpdatedData(props.rowData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.rowData]);

  const DataForm = (props) => {
    const onClickEdit = () => {
      setDisableForm(false);
    }

    const onClickDiscardEdit = () => {
      setDisableForm(true);
    }

    let initData = JSON.parse(localStorage.getItem('subUserForm')) || (props?.mode != ADMIN_FORM_MODES.add && updatedRowData) || {
      agentSubMap: null,
      fwpSubMap: null,
      username: '',
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
      passwordHint: '',
      appPlanUser: null,
      appProfileUser: null,
      userGroups: [{ id: "-1_none", name: 'None' }],
      userCampaigns: [{ campaignId: "-1_none", campaignName: 'None' }],
      userSkills: [{ id: "-1_none", skillName: 'None' }],
      userIvr: [{ flowId: "-1_none", flowName: 'None' }],
      userGroupsData: [],
      userCampaignsData: [],
      userSkillsData: [],
      accountLocked: false,
      enabled: true,
      accountExpired: false,
      credentialsExpired: false,
      continueBarge: false,
      sipLocationExtension: '',
      sipBargeExtension: '',
      extension: '',
      phoneNumber: '',

      //non present fields
      appModules: [],
      userTimezone: "",
      serverTimezone: "Asia/Kolkata",
      allowedIp: '',
      screenPopMode: '',
      callbackUrl: '',
      website: '',

      userLocation: "AddressData",//NotRequired Field
      city: "kakinada",//required Field
      province: "sttate",//required Field
      postalCode: "533001",//required Field
      country: "IN",//required Field
    }

    const validationSchema = useMemo(() => (yup.object({
      username: yup
        .string('Enter Sub Username')
        .test("maxDigits",
          "Sub Username should be between 3 to 50 alphanumeric characters long and allows special characters like .,@,_,-",
          (number) => String(number).length >= 3 && String(number).length <= 50)
        .matches(/^[A-Za-z\d]+([.\@_\-]+[A-Za-z\d]+)*$/, "Sub Username should be between 3 to 50 alphanumeric characters long and allows special characters like .,@,_,-")
        .required('Sub Username is required'),
      firstName: yup
        .string("Enter First Name")
        .test("maxDigits",
          "First Name should be between 3 to 50 alphanumeric characters long and allows special characters like _",
          (number) => String(number).length >= 3 && String(number).length <= 50)
        .matches(/^([A-Za-z0-9]((_)?[A-Za-z0-9])+)$/, "First Name should be between 3 to 50 alphanumeric characters long and allows special characters like _")
        .required('First Name is required'),
      lastName: yup
        .string("Enter Last Name")
        .test("maxDigits",
          "Last Name should be between 3 to 50 alphanumeric characters long and allows special characters like _",
          (number) => String(number).length >= 3 && String(number).length <= 50)
        .matches(/^([A-Za-z0-9]((_)?[A-Za-z0-9])+)$/, "Last Name should be between 3 to 50 alphanumeric characters long and allows special characters like _")
        .required('Last Name is required'),
      email: yup
        .string("Enter Last Name")
        .email('enter valid email')
        .test("maxDigits",
          "E-Mail should be a valid email.",
          (number) => String(number).length >= 5 && String(number).length <= 50)
        .required('Email is required'),
      sipBargeExtension: yup
        .mixed()
        .when([], {
          is: () => inputSipField === true,
          then: yup
            .number()
            .test("maxDigits",
              "SIP Barge Extension should be at most 10 characters",
              (value) => !value || String(value).length <= 10).nullable(),
          otherwise: yup.mixed()
        }),
      password: props?.mode === ADMIN_FORM_MODES.add
        ? yup
          .string("Enter Password")
          // .required('Password is required')
          .test(
            "maxDigits",
            "The password must not contain spaces. The password must be 8 to 50 characters, including an uppercase letter, a lowercase letter, a special character, and alphanumeric characters.",
            (value) => {
              if (props?.mode === ADMIN_FORM_MODES.add) {
                return true;
              }
              // String(value).length >= 7 && String(value).length <= 50
            }
          )
          .matches(
            /^((?!.*[\s])(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[-_!@#$%^&*()+{}[\]:;<>,.?~]).{8,50})$/,
            "The password must not contain spaces. The password must be 8 to 50 characters, including an uppercase letter, a lowercase letter, a special character, and alphanumeric characters."
          )
        : yup
          .string()
          .required('Password is required')
          .test(
            'password-valid',
            'The password must be 8 to 50 characters, including an uppercase letter, a lowercase letter, a special character, and alphanumeric characters.',
            (value) => {
              // Use the logic from `getValidationInEditMode`

              if (value === props?.rowData?.password) return true;
              if (!value) return false;

              // Apply regex validation for the password
              const regex = /^((?!.*[\s])(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[-_!@#$%^&*()+{}[\]:;<>,.?~]).{8,50})$/;
              return regex.test(value);
            }
          ),
      appProfileUser: yup
        .object()
        .nullable()
        .required("Profile Selection is required."),
      extension: yup
        .string("Enter Extension")
        .required('Extension is required'),
      phoneNumber: yup
        .string("Enter Phone Number")
        .required('Phone Number is required'),
    })), []);

    function setFinalValue(data, itemVal, idKey, valueKey, finalData) {
      if (data[itemVal]?.length === 1) {
        if (data[itemVal][0][idKey] === "0_all") {
          finalData[valueKey] = "0";
          finalData[itemVal] = [];
          return;
        } else if (data[itemVal][0][idKey] === "-1_none") {
          finalData[valueKey] = "-1";
          finalData[itemVal] = [];
          return;
        }
      }
      finalData[valueKey] = "-2";
      return;
    }

    async function addUser(data) {
      setLoading(true);
      try {
        let finalData = structuredClone(data);

        finalData.appProfileUser = [data.appProfileUser]

        const loggedinUser = await getUserLoggedIn();
        const loggedinUserData = loggedinUser?.Data[0];
        if (data.allowedIp === "") {
          finalData.allowedIp = null;
        }
        setFinalValue(data, "userCampaigns", "campaignId", "isCampaignValue", finalData);
        setFinalValue(data, "userGroups", "id", "isGroupValue", finalData);
        setFinalValue(data, "userSkills", "id", "isSkillValue", finalData);
        setFinalValue(data, "userIvr", "flowId", "isFlowValue", finalData);

        finalData.userTimezone = loggedinUserData.userTimezone;
        finalData.serverTimezone = loggedinUserData.serverTimezone;
        finalData.screenPopMode = loggedinUserData.screenPopMode;
        finalData.callbackUrl = loggedinUserData.callbackUrl;

        addsubadmin(finalData)
          .then((resp) => {
            if (resp.Status === "Success") {
              showSuccessNotification(`Sub User ${finalData.username} Created Successfully`);
              showInfoNotification(`Sub User creation email will be sent to ${finalData.email}`);
              props.onClose();
              props.updateFunction();
              setLoading(false);
            }
            else {
              showWarningNotification(resp.Message.allowedIp || resp.Message.username || resp.Message.firstName || resp.Message.lastName || resp.Message.email || resp.Message.screenPopMode || resp.Message.chatApiKey || resp.Message.callsApiKey || resp.Message.extension || resp.Message.phoneNumber ||
                resp.Message.apiKey || resp.Message.city || resp.Message.province || resp.Message.postalCode || resp.Message.country || resp.Message.userTimezone || resp.Message.urlMap || resp.Message.serverTimezone || resp.Message.dialerMapping || resp.Message.roles || resp.Message);
              setLoading(false);
            }
          })
          .catch((e) => {
            showErrorNotification("Error adding Sub User");
            setLoading(false);
          });
      } catch (e) {
        showErrorNotification("Error in adding Sub User");
        setLoading(false);
      }
    };

    async function updateUser(data) {
      setLoading(true);
      try {
        let finalData = structuredClone(data);
        finalData.appProfileUser = [data.appProfileUser]
        let isPasswordUpdate = false;
        if (props?.rowData?.password !== data?.password) {
          isPasswordUpdate = true;
          finalData.confirmPassword = finalData.password;
        }
        finalData.is_update = isPasswordUpdate;
        if (data.allowedIp === "") {
          finalData.allowedIp = null;
        }
        setFinalValue(data, "userCampaigns", "campaignId", "isCampaignValue", finalData);
        setFinalValue(data, "userGroups", "id", "isGroupValue", finalData);
        setFinalValue(data, "userSkills", "id", "isSkillValue", finalData);
        setFinalValue(data, "userIvr", "flowId", "isFlowValue", finalData);

        updatesubadminById(finalData)
          .then((resp) => {
            if (resp.Status === "Success") {
              showSuccessNotification(`Sub User ${finalData.username} Updated Successfully`);
              props.onClose();
              props.updateFunction();
              setLoading(false);
            }
            else {
              showWarningNotification(resp.Message.allowedIp || resp.Message.username || resp.Message.firstName || resp.Message.lastName || resp.Message.email || resp.Message.screenPopMode || resp.Message.chatApiKey || resp.Message.callsApiKey || resp.Message.extension || resp.Message.phoneNumber ||
                resp.Message.apiKey || resp.Message.city || resp.Message.province || resp.Message.postalCode || resp.Message.country || resp.Message.userTimezone || resp.Message.urlMap || resp.Message.serverTimezone || resp.Message.dialerMapping || resp.Message.roles || resp.Message);
              setLoading(false);
            }
          })
          .catch((e) => {
            showErrorNotification("Error updating Sub User");
            setLoading(false);
          });
      }
      catch (e) {
        showErrorNotification("Error updating Sub User");
        setLoading(false);
      }
    };

    function getAccessToShowConfig(profile, typeAsked) {
      let data = structuredClone(profile);
      let tempData = JSON.parse(data?.profileSetting);
      let flag = false;

      Object.keys(tempData).forEach(key => {
        const value = tempData[key];

        if (key === 'viewAccess') {
          if (value.includes(typeAsked)) {
            flag = true;
          }
        }
        if (key === 'editAccess') {
          if (value.includes(typeAsked)) {
            flag = true;
          }
        }
        if (key === 'fullAccess') {
          if (value.includes(typeAsked)) {
            flag = true;
          }
        }
        if (key === 'dataUpload') {
          if (value.includes(typeAsked)) {
            flag = true;
          }
        }
      });
      return flag;
    }

    const [showPassword, setShowPassword] = useState(false);
    const handlePasswordVisibility = (e) => {
      e.preventDefault()
      setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    return (
      <div className="ozAddSubAdminForm">
        <Formik
          initialValues={initData}
          validateOnMount
          validationSchema={validationSchema}
          onSubmit={(data) => {
            let subUserFormData = structuredClone(data);
            localStorage.setItem('subUserForm', JSON.stringify(data))
            if (!props?.subUserAgentMapping) {
              subUserFormData.agentSubMap = null;
              subUserFormData.fwpSubMap = null;
            }
            if (props?.mode === ADMIN_FORM_MODES.add) {
              addUser(subUserFormData);
            } else {
              updateUser(subUserFormData);
            }
          }}
        >
          {(propsForm) => (
            <form
              onSubmit={propsForm.handleSubmit}
              id="userForm"
              className="ozcw-scrollbar"
            >
              <Grid container={true} display="flex">
                <div
                  style={{
                    marginLeft: "80px",
                  }}
                >
                  <Typography
                    className="oz-page-header"
                    onClick={props.onClose}
                  >
                    {" "}
                    Sub User / Add Sub User{" "}
                  </Typography>
                  <Typography className="oz-page-heading">
                    {" "}
                    {props?.mode === ADMIN_FORM_MODES.add ? "Sub User Creation" : props?.rowData?.username}{" "}
                  </Typography>
                  <div
                    style={{
                      paddingTop: "16px",
                      paddingBottom: "16px",
                      borderRadius: "8px",
                      backgroundColor: "#FFFFFF",
                      width: "81vw",
                    }}
                  >
                    <Grid
                      className="fieldsStyle"
                      container
                      spacing="20px"
                    >
                      {props?.mode != ADMIN_FORM_MODES.add && props?.editAccess && writeAccess() && (
                        <>
                          <Typography
                            style={{ fontSize: '14px', marginLeft: 'auto', marginRight: '2%', color: '#3D8BF8' }}
                            className="oz-page-header"
                            onClick={() => {
                              if (disableForm) {
                                onClickEdit();
                              } else {
                                propsForm.resetForm({ values: props?.rowData });
                                onClickDiscardEdit();
                              }
                            }}
                          >
                            {" "}
                            {disableForm ? 'Edit' : 'Discard Edit'}{" "}
                          </Typography>
                        </>
                      )}
                      <Grid
                        className="fieldsStyle"
                        container
                        spacing="20px"
                      >
                        <Grid item xs={5}>
                          <OZInput
                            name="username"
                            label="Sub Username *"
                            placeholder="Sub Username"
                            disabled={disableForm}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={5}>
                        <OZInput
                          name="firstName"
                          label="First Name *"
                          placeholder="First Name"
                          disabled={disableForm}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <OZInput
                          name="lastName"
                          label="Last Name *"
                          placeholder="Last Name"
                          disabled={disableForm}
                        />
                      </Grid>
                      <Grid item xs={5}>
                        <OZInput
                          name="email"
                          label="Email *"
                          placeholder="Email Address"
                          disabled={disableForm}
                        />
                        <label style={{ color: "#4a5363", fontSize: "10px", paddingLeft: '2px' }}>Sub User  will receive invite email on this Email ID</label>
                      </Grid>

                      <Grid item xs={5}>
                        <OZSelect
                          name="appProfileUser"
                          label="Choose Sub User Profile *"
                          options={profileListData}
                          optionLabel="name"
                          placeholder="Select"
                          disabled={disableForm}
                        />
                      </Grid>
                      {props?.subUserAgentMapping &&
                        <>
                          <Grid item xs={5}>
                            <CustomAutoComplete
                              mode='Add'
                              name="agentSubMap"
                              optionLabelName={"agentName"}
                              optionId='agentId'
                              labelHeader='Agent'
                              showAgentIdWithName={true}
                              placeholder={"Please Select"}
                              Datas={agentList}
                              multiple={false}
                              popupIcon={null}
                              disabled={disableForm}
                            />
                          </Grid>
                          <Grid item xs={5}>
                            <CustomAutoComplete
                              mode='Add'
                              name="fwpSubMap"
                              labelHeader='Agent Phone Number'
                              placeholder={"Please Select"}
                              Datas={fwpNumberList}
                              optionLabelName='phoneNumber'
                              multiple={false}
                              disabled={disableForm}
                              popupIcon={null}
                            />
                          </Grid>
                        </>
                      }
                      {checkRoles("ROLE_ADMIN") ? (
                        <Grid item xs={5}>
                          {inputSipField ? (
                            <OZInput
                              disabled={disableForm}
                              name="sipBargeExtension"
                              label="SIP Barge Extension"
                              placeholder="Enter Extension"
                              type="number"
                            />
                          ) : (
                            <OZSelect
                              disabled={disableForm}
                              name="sipBargeExtension"
                              label="SIP Barge Extension"
                              optionLabel="displayCRMIn"
                              options={sipBargeExtensionData}
                              placeholder="Enter Extension URL"
                            />
                          )}
                        </Grid>
                      ) : (
                        <></>
                      )}
                      {checkRoles("ROLE_ADMIN") ? (
                        <Grid item xs={5}>
                          <OZInput
                            disabled={disableForm}
                            name="sipLocationExtension"
                            label="SIP Location Extension"
                            placeholder="Enter Location"
                            fieldType="url"
                          />
                        </Grid>
                      ) : (
                        <></>
                      )}
                      <Grid
                        className="fieldsStyle"
                        container
                        spacing="20px"
                      >
                        <Grid item xs={5}>
                          <OZInput
                            name="allowedIp"
                            label="Allowed IPs"
                            placeholder="Enter IPs"
                            disabled={disableForm}
                            fieldType="url"
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={3.3}>
                        <OZInput
                          name="extension"
                          label="Extension *"
                          placeholder="Extension"
                          disabled={disableForm}
                        />
                      </Grid>
                      <Grid item xs={3.3}>
                        <OZInput
                          name="phoneNumber"
                          label="Phone Number *"
                          placeholder="***********"
                          disabled={disableForm}
                        />
                      </Grid>
                      <Grid item xs={3.4}>
                        <OZInput
                          name="website"
                          label="Website"
                          placeholder="Website"
                          fieldType="url"
                          disabled={disableForm}
                        />
                      </Grid>
                      {(props.mode !== ADMIN_FORM_MODES.add) && <> <Grid item xs={3.3}>
                        <OZInput
                          name="password"
                          label="Password *"
                          placeholder="Password"
                          type={showPassword ? 'string' : "password"}
                          disabled={disableForm}
                          InputProps={!disableForm ? {
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="oz-cx-password-icon"
                                  onClick={handlePasswordVisibility}
                                  // onMouseDown={handleMouseDownPassword}
                                  edge="end"
                                >
                                  {showPassword ? <HidePassword className='oz-cx-password-icon' /> : <ShowPassword className='oz-cx-password-icon' />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          } : {}}
                        />
                      </Grid>
                      </>}
                      <Grid
                        className="fieldsStyle"
                        container
                        spacing="20px"
                      >
                        <Grid item xs={5} style={{ marginLeft: '0.5%' }}>
                          {checkRoles("ROLE_CONTINUE_BARGE") ? (
                            <div className='oz-user-form-view-sub' style={{ marginLeft: '0% ! important' }}>
                              <div>
                                <SimpleSwitch name='continueBarge' disabled={disableForm} checked={propsForm?.values?.continueBarge}
                                  onChange={(e) => { propsForm?.setFieldValue('continueBarge', e.target.checked) }}
                                />
                              </div>
                              <Typography sx={styleFieldHeader} color={disableForm ? '#99A0A8' : '#212121'}>
                                Continuous Barge-in
                              </Typography>
                            </div>
                          ) : null}
                        </Grid>
                      </Grid>
                    </Grid>
                    {(propsForm?.values?.appProfileUser != null) && (getAccessToShowConfig(propsForm?.values?.appProfileUser, 'Campaigns') || getAccessToShowConfig(propsForm?.values?.appProfileUser, 'Agents') || getAccessToShowConfig(propsForm?.values?.appProfileUser, 'Skills')) && (
                      <>
                        <div
                          style={{
                            paddingTop: "32px",
                            color: "#212121",
                            fontSize: "18px",
                            display: "flex",
                            flexDirection: "column",
                            paddingLeft: "20px",
                            lineHeight: "21px",
                            fontWeight: 400,
                          }}
                        >
                          <label>Configuration Access</label>
                          <label style={{ color: "#4a5363", fontSize: "12px" }}>Configure the required acces to the user</label>
                        </div>
                        <Divider style={{ borderStyle: 'dotted', width: '81.5%', marginLeft: "20px" }} />
                        <Grid xs={12} className="fieldsStyle" container spacing={2}>
                          {getAccessToShowConfig(propsForm?.values?.appProfileUser, 'Campaigns') &&
                            <Grid item xs={3.4}>
                              <CustomAutoComplete
                                mode='Add'
                                limitTags={2}
                                name="userCampaigns"
                                labelHeader='Campaigns'
                                placeholder={"Please Select"}
                                Datas={campaignListData}
                                optionLabelName='campaignName'
                                objId='campaignId'
                                showCheckBox={true}
                                multiple={true}
                                showAllOption="true"
                                showNoneOption="true"
                                showselectall="true"
                                popupIcon={null}
                                disabled={disableForm}
                              />
                              {propsForm?.values?.userCampaigns?.length > 0 && (
                                <div style={styles.box}>
                                  <div style={styles.arrow}></div>
                                  <p style={styles.text}>User will only have access to selected Campaigns</p>
                                </div>
                              )}
                            </Grid>
                          }
                          {getAccessToShowConfig(propsForm?.values?.appProfileUser, 'Skills') &&
                            <Grid item xs={3.4}>
                              <CustomAutoComplete
                                mode='Add'
                                limitTags={3}
                                name="userSkills"
                                labelHeader='Skills'
                                placeholder={"Please Select"}
                                Datas={skillsListData}
                                optionLabelName='skillName'
                                showCheckBox={true}
                                multiple={true}
                                showAllOption="true"
                                showNoneOption="true"
                                showselectall="true"
                                popupIcon={null}
                                disabled={disableForm}
                              />
                              {propsForm?.values?.userSkills?.length > 0 && (
                                <div style={styles.box}>
                                  <div style={styles.arrow}></div>
                                  <p style={styles.text}>User will only have access to selected Skills</p>
                                </div>
                              )}
                            </Grid>
                          }
                          {getAccessToShowConfig(propsForm?.values?.appProfileUser, 'Agents') &&
                            <Grid item xs={3.4}>
                              <CustomAutoComplete
                                mode='Add'
                                limitTags={2}
                                name="userGroups"
                                labelHeader='Agent Groups'
                                placeholder={"Please Select"}
                                Datas={agentGrpListData}
                                optionLabelName='name'
                                showCheckBox={true}
                                multiple={true}
                                showAllOption="true"
                                showNoneOption="true"
                                showselectall="true"
                                popupIcon={null}
                                disabled={disableForm}
                              />
                              {propsForm?.values?.userGroups?.length > 0 && (
                                <div style={styles.box}>
                                  <div style={styles.arrow}></div>
                                  <p style={styles.text}>User will only have access to selected Groups</p>
                                </div>
                              )}
                            </Grid>
                          }

                          {getAccessToShowConfig(propsForm?.values?.appProfileUser, 'IVR Flows') &&
                            <Grid item xs={3.4}>
                              <CustomAutoComplete
                                mode='Add'
                                limitTags={2}
                                name="userIvr"
                                labelHeader='IVR Flows'
                                placeholder={"Please Select"}
                                Datas={ivrList}
                                optionLabelName='flowName'
                                objId='flowId'
                                showCheckBox={true}
                                multiple={true}
                                showAllOption="true"
                                showNoneOption="true"
                                showselectall="true"
                                popupIcon={null}
                                disabled={disableForm}
                              />
                              {propsForm?.values?.userIvr?.length > 0 && (
                                <div style={styles.box}>
                                  <div style={styles.arrow}></div>
                                  <p style={styles.text}>User will only have access to selected IVR Flows</p>
                                </div>
                              )}
                            </Grid>
                          }

                        </Grid>
                        {(checkRoles("ROLE_DATA_ACCESS")) && (
                          <>
                            <div
                              style={{
                                paddingTop: "32px",
                                color: "#212121",
                                fontSize: "18px",
                                display: "flex",
                                flexDirection: "column",
                                paddingLeft: "20px",
                                lineHeight: "21px",
                                fontWeight: 400,
                              }}
                            >
                              <label>Data Access</label>
                              <label style={{ color: "#4a5363", fontSize: "12px" }}>Configure the required acces to the user</label>
                            </div>
                            <Divider style={{ borderStyle: 'dotted', width: '81.5%', marginLeft: "20px" }} />

                            <Grid xs={12} className="fieldsStyle" container spacing={2}>
                              {/* {getAccessToShowConfig(propsForm?.values?.appProfileUser, 'Campaigns') && */}
                              <Grid item xs={3.4}>
                                <CustomAutoComplete
                                  mode='Add'
                                  limitTags={2}
                                  name="userCampaignsData"
                                  labelHeader='Campaigns'
                                  placeholder={"Please Select"}
                                  Datas={campaignListData}
                                  optionLabelName='campaignName'
                                  objId='campaignId'
                                  showCheckBox={true}
                                  multiple={true}
                                  showselectall="true"
                                  popupIcon={null}
                                  disabled={disableForm}
                                />
                                {propsForm?.values?.userCampaignsData?.length > 0 && (
                                  <div style={styles.box}>
                                    <div style={styles.arrow}></div>
                                    <p style={styles.text}>User will only have data access to selected Campaigns</p>
                                  </div>
                                )}
                              </Grid>
                              {/* } */}
                              {/* {getAccessToShowConfig(propsForm?.values?.appProfileUser, 'Skills') && */}
                              <Grid item xs={3.4}>
                                <CustomAutoComplete
                                  mode='Add'
                                  limitTags={3}
                                  name="userSkillsData"
                                  labelHeader='Skills'
                                  placeholder={"Please Select"}
                                  Datas={skillsListData}
                                  optionLabelName='skillName'
                                  // objId='campaignId'
                                  showCheckBox={true}
                                  multiple={true}
                                  showselectall="true"
                                  popupIcon={null}
                                  disabled={disableForm}
                                />
                                {propsForm?.values?.userSkillsData?.length > 0 && (
                                  <div style={styles.box}>
                                    <div style={styles.arrow}></div>
                                    <p style={styles.text}>User will only have data access to selected Skills</p>
                                  </div>
                                )}
                              </Grid>
                              {/* } */}
                              {/* {getAccessToShowConfig(propsForm?.values?.appProfileUser, 'Agents') && */}
                              <Grid item xs={3.4}>
                                <CustomAutoComplete
                                  mode='Add'
                                  limitTags={2}
                                  name="userGroupsData"
                                  labelHeader='Agent Groups'
                                  placeholder={"Please Select"}
                                  Datas={agentGrpListData}
                                  optionLabelName='name'
                                  showCheckBox={true}
                                  multiple={true}
                                  showselectall="true"
                                  popupIcon={null}
                                  disabled={disableForm}
                                />
                                {propsForm?.values?.userGroupsData?.length > 0 && (
                                  <div style={styles.box}>
                                    <div style={styles.arrow}></div>
                                    <p style={styles.text}>User will only have data access to selected Groups</p>
                                  </div>
                                )}
                              </Grid>
                              {/* } */}
                            </Grid>
                          </>
                        )}
                      </>
                    )}
                    <Grid
                      container
                      style={{ paddingTop: "43px", paddingRight: "20px" }}
                      justifyContent="end"
                    >
                      <Grid item>
                        <Button
                          onClick={props?.onClose}
                          variant="outlined"
                          className="cancelButton"
                        >
                          Cancel
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          onClick={() => {
                            propsForm.handleSubmit();
                          }}
                          variant="contained"
                          className="nextButton"
                          disabled={disableForm}
                        >
                          Save
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                </div>
              </Grid>
              <ScrollToFieldError />
            </form>
          )}
        </Formik>
      </div>
    );
  }

  return (
    <div>
      <div>
        <DataForm {...props} />
      </div>
      {loading &&
        <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: '0,0,0,0.5', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <LoadingScreen />
        </div>
      }
    </div>
  );
};

export default AddSubUser;